var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between py-8 md:px-2"},[_c('logo',{attrs:{"variant":"reverse"}}),_c('AccountSwitcher',{attrs:{"profile":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }